<template>
  <div v-show="visible" class="shareCard-wrap">
    <div class="shareCard" :class="cardClass">
      <div v-if="showClose" class="close-btn">
        <svg-icon iconClass="close" @click="$emit('close')" />
      </div>
      <!-- 匿名登入特殊佈局 -->
      <div v-if="isAnonymousLogin" class="anonymous-login-layout">
        <div class="welcome-title">{{ welcomeTitle }}</div>
        <div class="anonymous-title">{{ title }}</div>
        <slot />
        <div v-if="confirmText && canConfirm" class="save-btn" @click="$emit('confirm')">
          {{ confirmText }}
        </div>
        <div class="or-divider">{{ orText }}</div>
        <div class="login-btn" @click="$emit('login')">
          {{ loginText }}
        </div>
      </div>
      <!-- 一般模態框佈局 -->
      <div v-else>
        <div v-if="title" class="shareCard-title">{{ title }}</div>
        <slot />
        <div v-if="confirmText && canConfirm" class="save-btn" @click="$emit('confirm')">
          {{ confirmText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue'

export default {
  name: 'BaseModal',
  components: { SvgIcon },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: ''
    },
    canConfirm: {
      type: Boolean,
      default: true
    },
    cardClass: {
      type: String,
      default: ''
    },
    isAnonymousLogin: {
      type: Boolean,
      default: false
    },
    welcomeTitle: {
      type: String,
      default: ''
    },
    orText: {
      type: String,
      default: ''
    },
    loginText: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'confirm', 'login']
}
</script>

<style lang="less" scoped>
@import "../assets/color.less";

.shareCard-wrap {
  position: fixed;
  display: block;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: 0.5s;
  color: black;
  height: 100%;
  z-index: 1004;
  overflow: hidden;

  .shareCard {
    position: relative;
    display: block;
    top: 10%;
    transition: 0.5s;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    font-weight: bolder;
    padding: 8px 20px 20px 20px;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    z-index: 102;
    text-align: center;
    min-width: 350px;

    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      font-size: 20px;
      color: @text-color;
    }

    .shareCard-title {
      font-size: 20px;
      margin: 10px 40px;
    }

    .save-btn {
      display: inline-block;
      width: auto;
      line-height: 30px;
      padding: 2px 10px;
      margin: 8px 5px 0px 5px;
      background-color: @light-color;
      border-radius: 4px;
      color: white;
      cursor: pointer;
    }

    // 匿名登入特殊佈局樣式
    .anonymous-login-layout {
      text-align: center;
      
      .welcome-title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin: 10px 0;
        border-bottom: 2px solid #333;
        padding-bottom: 8px;
      }
      
      .anonymous-title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin: 15px 0 10px 0;
      }
      
      .or-divider {
        font-size: 20px;
        color: #333;
        margin: 15px 0;
        font-weight: bold;
      }
      
      .login-btn {
        display: inline-block;
        line-height: 40px;
        padding: 4px 16px;
        margin: 8px 0;
        background-color: @light-color;
        font-weight: bold;
        border-radius: 8px;
        color: white;
        cursor: pointer;
        font-size: 16px;
        
        &:hover {
          background-color: darken(@light-color, 10%);
        }
      }
    }
  }

  .rename-wrap {
    display: block;
    width: 95%;
    margin: 0 auto;
    margin-top: 10px;

    .rename-bar {
      position: relative;
      display: flex;
      border-radius: 8px;
      background: white;

      input {
        border: @darken-gray 2px solid;
        width: 100%;
        height: 40px;
        padding: 8px 16px;
        color: #1f2937;
        font-size: 20px;
        border-radius: 8px;
        outline: none;

        &:focus {
          border: @light-color 2px solid;
        }
      }

      textarea {
        border: @darken-gray 2px solid;
        width: 100%;
        height: 80px;
        padding: 8px 16px;
        color: #1f2937;
        font-size: 20px;
        border-radius: 8px;
        outline: none;

        &:focus {
          border: @light-color 2px solid;
        }
      }

      .delete-btn {
        position: absolute;
        margin-right: 8px;
        margin-top: 0;
        cursor: pointer;
        color: gray;
        top: 8px;
        font-size: 16px;
        right: 6px;
      }
    }
  }
}
</style>